var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUploadIconBox = function SvgUploadIconBox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#EAB308",
    clipPath: "url(#upload-icon-box_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.333 16.667h-6.666v6.666h6.666v10H6.667v-10h6.666v-6.666H6.667A6.666 6.666 0 0 0 0 23.333v10A6.667 6.667 0 0 0 6.667 40h26.666A6.667 6.667 0 0 0 40 33.333v-10a6.667 6.667 0 0 0-6.667-6.666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.72.6-8.333 10a1.666 1.666 0 0 0 1.28 2.733h5v15A1.667 1.667 0 0 0 18.333 30h3.334a1.667 1.667 0 0 0 1.666-1.667v-15h5a1.666 1.666 0 0 0 1.28-2.733L21.28.6a1.723 1.723 0 0 0-2.433-.127z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "upload-icon-box_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })))));
};
export default SvgUploadIconBox;